<app-breadcrumb></app-breadcrumb>

<!-- <div *ngIf="successMessage!=null" class="alert alert-success alert-dismissible fade show" role="alert">
    <button type="button" class="btn-close" (click)="close()" data-bs-dismiss="alert" aria-label="close"></button>
    <strong>{{successMessage}}</strong>
</div>
<div *ngIf="errorMessage!=null" class="alert alert-danger alert-dismissible">
    <button type="button" class="btn-close" (click)="close()" data-bs-dismiss="alert" aria-label="close"></button>
    <strong>{{errorMessage}}</strong>
</div> -->

<app-notification-message
  [errorMessage]="errorMessage"
  [successMessage]="successMessage"
>
</app-notification-message>

<div class="d-flex justify-content-between align-items-center ms-4 me-4 mb-2">
  <h2 class="roboto-medium">Event Details</h2>
  <div class="d-flex gap-2 align-items-center">
    <fa-icon
      *ngIf="conn"
      [icon]="faFileExcel"
      style="cursor: pointer"
      (click)="downloadConnections()"
    ></fa-icon>
    <span class="subtitle" *ngIf="conn" (click)="downloadConnections()"
      >EXPORT ALL CONNECTIONS</span
    >
    <button
      *ngIf="!fromDashboard && isAccessible"
      class="b2 roboto-medium"
      [disabled]="reOpen"
      [ngClass]="{ 'disable-reopen': reOpen }"
      (click)="reOpenHistory()"
    >
      REOPEN
    </button>
    <button class="mb-1 me-0 black-button" (click)="viewHistory()">View Edit History</button>
    <button *ngIf="fromDashboard" class="mb-1 me-0 black-button" (click)="openEditEvent()">UPDATE</button>
    <button *ngIf="fromDashboard" class="mb-1 me-0 black-button" style="cursor: not-allowed;">SNOOZE</button>
    <button *ngIf="fromDashboard" class="mb-1 me-0 black-button" style="cursor: not-allowed;">SMS</button>
    <button *ngIf="fromDashboard" class="mb-1 me-0 black-button" (click)="onBacktoDashboard()">BACK</button>
    <button *ngIf="fromDashboard" class="mb-1 me-0 black-button" (click)="openLegends()">legends</button>
  </div>
</div>
<header>
  <div class="container ms-4 ps-0">
    <div class="row">
      <div class="icon" (click)="openMenu()">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="menu roboto-medium" [class.menuClass]="menuVariable">
        <ul class="d-flex">
          <li
            class="bar"
            [routerLink]="activeLinks.eventsdetail"
            routerLinkActive="active-link"
          >
            Event
          </li>
          <div class="vr"></div>
          <li
            class="bar"
            [routerLink]="activeLinks.resolutions"
            routerLinkActive="active-link"
          >
            Resolutions
          </li>
          <div class="vr"></div>
          <li
            class="bar"
            [routerLink]="activeLinks.connections"
            routerLinkActive="active-link"
          >
            Connections
          </li>
          <div class="vr"></div>
          <li
            class="bar"
            [routerLink]="activeLinks.eventhistory"
            routerLinkActive="active-link"
          >
            Event History
          </li>
          <div *ngIf="gpsCheck" class="vr"></div>
          <li *ngIf="gpsCheck"
            class="bar"
           
          >
            <a href="https://macropoint-lite.com/LogOn.aspx?ReturnUrl=%2f" target="_blank">GPS</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</header>

<hr class="ms-4 me-4 mb-0" />
<br />
